export default "__VITE_ASSET__38d77625__";